import React from 'react';
import { connect } from 'react-redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { AppState, BrokerDetails, Menu } from 'acscp/store';
import style from './contactAccountManager.module.scss';
import { Dispatch } from 'redux';
import { FetchRequest, SetOpenMenu } from 'acscp/actions';
import { AllBrokerDetailsRequest } from 'acscp/api/requests';
import { CroppedImage } from 'acscp/components/common/croppedImage';
import { FormattedMessage } from 'react-intl';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';

interface ContactAccountManagerStateProps {
    broker?: BrokerDetails;
    isLoggedIn: boolean;
}

interface ContactAccountManagerDispatchProps {
    openBrokerDetailsMenu: () => void;
    fetchBrokerDetails: () => void;
}

export class ContactAccountManagerPresentational extends PresentationComponentBase<{},
    ContactAccountManagerStateProps, ContactAccountManagerDispatchProps, {}> {

    componentDidMount(): void {
        if (this.props.isLoggedIn) {
            this.props.fetchBrokerDetails();
        }
    }

    render(): JSX.Element | null {
        const { broker } = this.props;
        if (broker !== undefined) {
            const url = broker.image ? broker.image.url : undefined;
            return (
                <a href="javascript:;" onClick={this.props.openBrokerDetailsMenu}>
                    <div className={style.BrokerImageContainer}>
                        <div className={style.BrokerImage}>
                            <CroppedImage ratio={1} src={url} />
                        </div>
                        <div className={style.ContactAccountManager}>
                            <div className={style.InnerMobile}>
                            <FormattedMessage
                                id={'components.auth.contactAccountManager.contact'}
                                defaultMessage={'Contact'}
                            />
                            </div>
                            <div className={style.InnerDesktop}>
                            <FormattedMessage
                                id={'components.auth.contactAccountManager.myAccountManager'}
                                defaultMessage={'MY ACCOUNT MANAGER'}
                            />
                            </div>
                        </div>
                    </div>
                </a>
            );
        } else {
            return null;
        }
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): ContactAccountManagerDispatchProps {
    return {
        openBrokerDetailsMenu: () => dispatch(new SetOpenMenu(Menu.BrokerDetails)),
        fetchBrokerDetails: () => dispatch(new FetchRequest(new AllBrokerDetailsRequest())),
    };
}

function mapStateToProps(state: AppState, ownProps: {}): ContactAccountManagerStateProps {
    return {
        broker: state.broker.broker,
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

export const ContactAccountManager = connect(mapStateToProps, mapDispatchToProps)
    (ContactAccountManagerPresentational);
